// src/Calendar.js
import React, { useState, useEffect } from "react";
import "./calendar.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import BoxDayInfo from "./components/boxDayInfo/BoxDayInfo";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import CalendarComponent from "./components/calendarComponent/CalendarComponent";

import { t } from "i18next";
import { setGlobalState } from "../../utils/state";
import { getFutureProgramWS } from "./api/calendarApi";
import { isEmpty } from "../../utils/validation";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { useScreenSize } from "../../ScreenSizeContext";
import { useSearchParams } from "react-router-dom";
import { gestioneSnackbar } from "../../utils/common";

const Calendar = () => {
  const isPC = useScreenSize();

  const [searchParams] = useSearchParams();
  const id_association = searchParams.get("admin");

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dataCalendar, setDataCalendar] = useState({});

  useEffect(() => {
    if (isEmpty(id_association)) {
      setGlobalState("selectedIdBottomBar", 4);
    }

    getFutureProgramWS({ id_association })
      .then((res) => {
        setDataCalendar(res);
      })
      .catch((err) => {
        gestioneSnackbar(true, err.message, "error");
      });
  }, [id_association]);

  return (
    <>
      <HeaderBar
        title={
          isEmpty(id_association)
            ? t("calendar.title")
            : t("dashboard.calendar")
        }
        back={!isEmpty(id_association)}
        path={"/dashboard/" + id_association}
      />
      <div className="container-responsive">
        <Row sm={1} lg={2} className="g-2">
          {!isEmpty(dataCalendar) ? (
            <>
              <Col className="d-flex justify-content-center">
                <CalendarComponent
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  data={dataCalendar.date}
                />
              </Col>
              <Col className="d-flex justify-content-center">
                <BoxDayInfo
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  dataOfDay={
                    dataCalendar.date[
                      moment(selectedDate).format("DD/MM/YYYY")
                    ] ?? {}
                  }
                  idAssociation={id_association}
                />
              </Col>
            </>
          ) : null}
        </Row>
        <VoidSpace height={isPC ? 0 : 70} />
      </div>
    </>
  );
};

export default Calendar;
